import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const purchaseList = createAsyncThunk('purchase-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}purchase/list`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const storePurchase = createAsyncThunk('purchase-store', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`${api}purchase/store`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

export const getPurchaseById = createAsyncThunk(
  'purchase-get',
  async (purchase_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}purchase/edit/` + purchase_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const approvePurchase = createAsyncThunk(
  'purchase-approve',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.post(`${api}purchase/approve/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const viewPurchase = createAsyncThunk(
  'purchase-view',
  async (purchase_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}purchase/view/` + purchase_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const purchaseReport = createAsyncThunk('purchase-report', async (params: any, thunkAPI) => {
  try {
    return await axios.get(`${api}purchase/report`, {params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const purchaseReportPrint = createAsyncThunk(
  'purchase-report-print',
  async (params: any, thunkAPI) => {
    try {
      const res = await axios.get(`${api}purchase/report-print`, {params})
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type PurchaseState = {
  errors: any
}

const initialState: PurchaseState = {
  errors: '',
}

export const purchaseSlice = createSlice({
  name: 'purchase',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storePurchase.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = purchaseSlice.actions
export default purchaseSlice.reducer
